import ImageQC from './ImageQC';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  const imageData = state.ui.imageData;
  let imageReady = false;
  Object.keys(imageData).forEach(k => {
    if (imageData[k].image) imageReady = true;
  });

  const viewportIndex = state.viewports.activeViewportIndex;
  const viewportData = state.viewports.viewportSpecificData[viewportIndex];
  const objectUid = viewportData && viewportData.sopInstanceUid;
  const thumbIndex = parseInt(window.localStorage.getItem('thumbIndex') || 0);

  return {
    imageReady,
    objectUid,
    context: state.ui.heatmapContext,
    thumbIndex,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedImageQC = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageQC);

export default ConnectedImageQC;
